import { BannerAdSearchComponent } from './banner-ads/banner-ad-search/banner-ad-search.component';
import { FeatureNameEnum } from './shared/feature/feature-name.enum';
import { ProfileWebContentComponent } from './profiles/profile-web-content/profile-web-content.component';
import { ManageWebContentComponent } from './web-content/manage-web-content/manage-web-content.component';
import { ProfileTransactionsComponent } from './profiles/profile-transactions/profile-transactions.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './shared/auth/auth-guard.service';

import { InitialTestComponent } from './test/initial-test.component';

import { WlCanDeactivateRouteGuard } from './shared/route/index';

//container components
//import { UnauthenticatedComponent } from './shared/container/unauthenticated/unauthenticated.component';
import { UnauthenticatedComponent } from './shared/container/unauthenticated-psfy/unauthenticated-psfy.component';
import { NoAccessComponent } from './shared/container/no-access/no-access.component';

//module components
//event comnponents
import { EventsDashboardComponent } from './events/dashboard/events-dashboard.component';
import { EventsSearchComponent } from './events/search/events-search.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardNeoComponent } from './dashboard-neo/dashboard-neo.component';
import { EventSettingsComponent } from './events/settings/event-settings.component';
import { RegistrationWizardComponent } from './events/registration/wizard/registration-wizard.component';
import { EventTypeEditComponent } from './events/event-type/event-type-edit.component';
import { SubmissionsComponent } from './events/submissions/submissions.component';
import { ImportRegistationsComponent } from './events/import/import-registrations/import-registations.component';

//benefit components
import { BenefitMgtComponent } from './benefits/benefit-mgt/benefit-mgt.component';
import { ProfileBenefitMgtComponent } from './benefits/profile-benefit-mgt/profile-benefit-mgt.component';

//integration components
import { CardConnectTransComponent } from './integrations/card-connect/card-connect-trans/card-connect-trans.component';
import { CardConnectInputComponent } from './integrations/card-connect/card-connect-input/card-connect-input.component';
import { MailChimpSyncComponent } from './integrations/mailchimp/mailchimp-sync.component';

//revenue components
import { ClassTypeEditComponent } from './revenue/class-type/class-type-edit.component';
import { CreditCardChargeComponent } from './revenue/credit-card-charge/credit-card-charge.component';
import { CreditCardTransactionsComponent } from './revenue/credit-card-transactions/credit-card-transactions.component';
import { ArcDashboardComponent } from './revenue/arc-builder/arc-dashboard.component';
import { ArcBuilderComponent } from './revenue/arc-builder/arc-builder.component';
import { InvoiceFinderComponent } from './revenue/invoice-finder/invoice-finder.component';
import { InvoiceGeneratorComponent } from './revenue/invoice-generator/invoice-generator.component';

// mass comm components
import { MassCommMessageAdminComponent } from './communication/mass-comm-message-admin/mass-comm-message-admin.component';
import { MassCommMessageEditComponent } from './communication/mass-comm-message-edit/mass-comm-message-edit.component';

import { ContentManagementLink } from './communication/content-management-link/content-management-link.component';
import { NewsArticlesSearchComponent } from './news-articles/news-articles-search/news-articles-search.component';
import { PublicLinksComponent } from './communication/public-links/public-links.component';

//profiles
import { ProfileSearchComponent } from './profiles/search/profile-search.component';
import { ProfileFinderComponent } from './profiles/profile-finder/profile-finder-component';
import { ProfileViewComponent } from './profiles/profile-view/profile-view.component';
import { ProfileEditComponent } from './profiles/profile-edit/profile-edit.component';
import { ProfileStatusComponent } from './profiles/profile-status/profile-status.component';
import { ProfileRelationshipsComponent } from './profiles/profile-relationships/profile-relationships.component';
import { ProfileContactsComponent } from './profiles/profile-contacts/index';
import { ProfileSalesOpportunitiesComponent } from './profiles/profile-sales-opportunities/profile-sales-opportunities.component';
import { ProfileTasksSearchComponent } from './profiles/profile-tasks/profile-tasks-search.component';
import { ProfileContactRecordsComponent } from './profiles/profile-contact-records/profile-contact-records.component';
import { ContactTypeSearchComponent } from './contacts/contact-type/search/contact-type-search.component';

//Admin compoents
import { HttpRequestItemsComponent } from './admin/http-request-items/http-request-items.component';
import { AdminSettingsComponent } from './admin/settings/admin-settings.component';
import { UserManagementComponent } from './users/user-management/user-management.component';
import { GlobalSettingsComponent } from './admin/global-settings/global-settings.component';

//Forem Builder Components
import { FormBuilderComponent } from './forms/form-builder.component';
import { FormsDashboardComponent } from './forms/forms-dashboard.component';

//Invoice Components
import { NewMemberInvoiceComponent } from './new-member/new-member-invoice/new-member-invoice.component';
import { InvoiceEditComponent } from './invoices/invoice-edit/invoice-edit.component';
import { SecurityElementNames } from './shared/auth/constants/security-element-names.service';
import { AccessControlEntry } from './shared/auth/access-control-entry';
import { CommitteeEditComponent } from './committees/committee-edit/committee-edit.component';
import { CommitteeSearchComponent } from './committees/committee-search/committee-search.component';
import { CommitteeMeetingEditComponent } from './committees/committee-meeting-edit/committee-meeting-edit.component';

// reports
import { ReportFilesComponent } from './reports/report-files/report-files.component';
import { ReportSavedQueriesComponent } from './reports/report-saved-queries/report-saved-queries.component';
import { CouponSearchComponent } from './coupons/coupon-search/coupon-search.component';
import { ManageCodesComponent } from './admin/codes/manage-codes/manage-codes.component';
import { QboAuthenticationLandingComponent } from './shared/component/qbo-authentication-landing/qbo-authentication-landing.component';
import { ReportQueryToolComponent } from './reports/report-query-tool/report-query-tool.component';
import { ReportsQueryToolSavedQueriesComponent } from './reports/reports-query-tool-saved-queries/reports-query-tool-saved-queries.component';
import { DataDictionaryComponent } from './reports/data-dictionary/data-dictionary.component';
import { ReportsRunAReportComponent } from './reports/reports-run-a-report/reports-run-a-report.component';
import { NAHBExportComponent } from './reports/nahb-export/nahb-export.component';
import { ProfileReferralValueReportComponent } from './profiles/profile-referral-value-report/profile-referral-value-report.component';
import { MassCommMessageAdminDraftsComponent } from './communication/mass-comm-message-admin/drafts/mass-comm-message-admin-drafts.component';
import { MassCommMessageAdminAnalyticsComponent } from './communication/mass-comm-message-admin/mass-comm-message-admin-analytics/mass-comm-message-admin-analytics.component';
import { MassCommMessageAdminRecurringComponent } from './communication/mass-comm-message-admin/recurring/mass-comm-message-admin-recurring.component';
import { MassCommMessageAdminScheduledMessagesComponent } from './communication/mass-comm-message-admin/scheduled/mass-comm-message-admin-scheduled-messages.component';
import { MassCommMessageAdminSentMessagesComponent } from './communication/mass-comm-message-admin/sent/mass-comm-message-admin-sent-messages.component';

const securityElementNames = new SecurityElementNames();

const routes: Routes = [
  { path: 'test/default', component: InitialTestComponent },
  { path: 'unauthenticated', component: UnauthenticatedComponent },
  // { path: 'unauthenticated-psfy', component: UnauthenticatedPsfyComponent },
  { path: 'access/denied', component: NoAccessComponent },
  {
    title: 'shared.container.top-nav.component.menu.dashboard.header',
    path: 'dashboard',
    component: DashboardNeoComponent,
    canActivate: [AuthGuard],
  }, //coming soon useAsDefault: true
  { title: 'events.dashboard.title', path: 'events/search', component: EventsSearchComponent, canActivate: [AuthGuard] },
  { path: 'event/:id', component: EventSettingsComponent, canActivate: [AuthGuard], canDeactivate: [WlCanDeactivateRouteGuard] },
  { title: 'common.settings', path: 'event/:id/settings', component: EventSettingsComponent, canActivate: [AuthGuard] },
  {
    title: 'events.dashboard.component.pending-registrations-label',
    path: 'event/:id/registrations/pending',
    component: EventSettingsComponent,
    canActivate: [AuthGuard],
  },
  { title: 'common.registrations', path: 'event/:id/registrations', component: EventSettingsComponent, canActivate: [AuthGuard] },
  { title: 'common.attendees', path: 'event/:id/attendees', component: EventSettingsComponent, canActivate: [AuthGuard] },
  { title: 'common.settings', path: 'event/:id/settings', component: EventSettingsComponent, canActivate: [AuthGuard] },
  {
    title: 'common.registration',
    path: 'event/:eventId/registration/:registrationId',
    component: RegistrationWizardComponent,
    canActivate: [AuthGuard],
  },
  {
    title: 'common.registration',
    path: 'event/:eventId/registration/new',
    component: RegistrationWizardComponent,
    canActivate: [AuthGuard],
  },
  { title: 'events.new.component.title', path: 'events/new', component: EventsDashboardComponent, canActivate: [AuthGuard] },
  {
    title: 'events.registration-import.header',
    path: 'events/import-registrations',
    component: ImportRegistationsComponent,
    canActivate: [AuthGuard],
  },
  { title: 'events.dashboard.title', path: 'events', component: EventsDashboardComponent, canActivate: [AuthGuard] },
  {
    title: 'events.event-type.event-type-edit-component.event-type-label',
    path: 'eventtypes/edit',
    component: EventTypeEditComponent,
    canActivate: [AuthGuard],
  },
  { title: 'revenue.class-type.class-type', path: 'classtypes/edit', component: ClassTypeEditComponent, canActivate: [AuthGuard] },
  { title: 'events.submissions.title', path: 'events/submissions', component: SubmissionsComponent, canActivate: [AuthGuard] },
  { title: 'benefits.benefit-mgt.title', path: 'benefits/management', component: BenefitMgtComponent, canActivate: [AuthGuard] },
  { title: 'common.benefits', path: 'benefits/profile/:id', component: ProfileBenefitMgtComponent, canActivate: [AuthGuard] },
  { title: 'revenue.title', path: 'revenue/invoices', component: InvoiceFinderComponent, canActivate: [AuthGuard] },
  { title: 'revenue.arc.arc-builder', path: 'revenue/pricing-calculations', component: ArcDashboardComponent, canActivate: [AuthGuard] },
  { path: 'revenue/pricing-calculations/:id', component: ArcBuilderComponent, canActivate: [AuthGuard] },
  {
    title: 'revenue.invoice-generator.title',
    path: 'revenue/invoice/generate',
    component: InvoiceGeneratorComponent,
    canActivate: [AuthGuard],
  },
  {
    title: 'revenue.invoice-new',
    path: 'revenue/invoice/new',
    component: InvoiceEditComponent,
    canActivate: [AuthGuard],
    data: {
      accessControls: [{ SecurityElement: securityElementNames.Revenue_Module, MinimumAccessLevel: 2 } as AccessControlEntry],
    },
  },
  {
    path: 'revenue/invoice/:id',
    component: InvoiceEditComponent,
    canActivate: [AuthGuard],
    data: {
      accessControls: [{ SecurityElement: securityElementNames.Revenue_Module, MinimumAccessLevel: 1 } as AccessControlEntry],
    },
  },
  {
    title: 'shared.container.top-nav.component.menu.revenue.card-connect-transactions',
    path: 'revenue/epayment/cardpointe/transactions',
    component: CardConnectTransComponent,
    canActivate: [AuthGuard],
  },
  {
    title: 'integrations.card-connect.title',
    path: 'revenue/epayment/cardconnect/input',
    component: CardConnectInputComponent,
    canActivate: [AuthGuard],
  },
  {
    title: 'revenue.credit-card-charge.title',
    path: 'revenue/epayment/creditcard/charge',
    component: CreditCardChargeComponent,
    canActivate: [AuthGuard],
  },
  {
    title: 'revenue.credit-card-transactions.title',
    path: 'revenue/epayment/creditcard/transactions',
    component: CreditCardTransactionsComponent,
    canActivate: [AuthGuard],
  },
  {
    title: 'profiles.profile-status.profile-status-label',
    path: 'profilestatuses/edit',
    component: ProfileStatusComponent,
    canActivate: [AuthGuard],
  },
  { title: 'profiles.new-member-invoice.title', path: 'profile/:id/new-member-invoice', component: NewMemberInvoiceComponent },
  {
    title: 'contacts.contact-type.contact-type-label',
    path: 'contacttypes/search',
    component: ContactTypeSearchComponent,
    canActivate: [AuthGuard],
  },
  {
    title: 'communications.mass-comm-message-admin.title',
    path: 'communications/message-admin',
    component: MassCommMessageAdminComponent,
    canActivate: [AuthGuard],
    canDeactivate: [WlCanDeactivateRouteGuard],
    children: [
      {
        path: 'analytics',
        component: MassCommMessageAdminAnalyticsComponent,
      },
      {
        path: 'drafts',
        component: MassCommMessageAdminDraftsComponent,
      },
      {
        path: 'recurring',
        component: MassCommMessageAdminRecurringComponent,
      },
      {
        path: 'scheduled',
        component: MassCommMessageAdminScheduledMessagesComponent,
      },
      {
        path: 'sent',
        component: MassCommMessageAdminSentMessagesComponent,
      },
    ],
  },
  {
    title: 'common.message',
    path: 'communications/message/:id',
    component: MassCommMessageEditComponent,
    canActivate: [AuthGuard],
    canDeactivate: [WlCanDeactivateRouteGuard],
  },
  {
    title: 'common.message',
    path: 'communications/message/copy/:id',
    component: MassCommMessageEditComponent,
    canActivate: [AuthGuard],
    data: { shouldCopy: true },
    canDeactivate: [WlCanDeactivateRouteGuard],
  },
  {
    title: 'common.message',
    path: 'communications/message/resend/:id',
    component: MassCommMessageEditComponent,
    canActivate: [AuthGuard],
    data: { isResend: true },
    canDeactivate: [WlCanDeactivateRouteGuard],
  },
  {
    title: 'common.message',
    path: 'communications/message/scheduled/:id',
    component: MassCommMessageEditComponent,
    canActivate: [AuthGuard],
    data: { isScheduled: true, isResend: true },
    canDeactivate: [WlCanDeactivateRouteGuard],
  },
  {
    title: 'common.draft',
    path: 'communications/message/draft/:id',
    component: MassCommMessageEditComponent,
    canActivate: [AuthGuard],
    data: { isDraft: true },
    canDeactivate: [WlCanDeactivateRouteGuard],
  },
  {
    title: 'common.draft',
    path: 'communications/message/draft/copy/:id',
    component: MassCommMessageEditComponent,
    canActivate: [AuthGuard],
    data: { shouldCopy: true, isDraft: true },
    canDeactivate: [WlCanDeactivateRouteGuard],
  },
  {
    title: 'communications.content-management.description',
    path: 'communications/content-management-link',
    component: ContentManagementLink,
    canActivate: [AuthGuard],
    canDeactivate: [WlCanDeactivateRouteGuard],
  },
  {
    title: 'news-articles.search.header',
    path: 'news-articles',
    component: NewsArticlesSearchComponent,
    canActivate: [AuthGuard],
    canDeactivate: [WlCanDeactivateRouteGuard],
  },
  { title: 'profiles.search.title', path: 'profiles/search', component: ProfileSearchComponent, canActivate: [AuthGuard] },
  { title: '', path: 'admin/http/request/items', component: HttpRequestItemsComponent },
  { title: 'admin.settings.title', path: 'admin/settings', component: AdminSettingsComponent, canActivate: [AuthGuard] },
  { title: '', path: 'forms/formbuilder/:id', component: FormBuilderComponent },
  { title: 'forms.form-builder.title', path: 'forms/formbuilder', component: FormBuilderComponent },
  { title: 'forms.dashboard.title', path: 'forms', component: FormsDashboardComponent },
  {
    title: 'integrations.mailchimp.mailchimp-sync.component.title',
    path: 'communications/mailchimp/sync',
    component: MailChimpSyncComponent,
  },
  {
    title: '',
    path: 'profile/:id',
    component: ProfileViewComponent,
    canActivate: [AuthGuard],
    data: {
      accessControls: [
        {
          SecurityElement: securityElementNames.Profiles_Module,
          MinimumAccessLevel: 1,
        } as AccessControlEntry,
      ],
    },
  },
  {
    title: 'referral.referral-value-report.header',
    path: 'referral/refferalValueReport/:profileId',
    component: ProfileReferralValueReportComponent,
    canActivate: [AuthGuard],
    data: {
      accessControls: [
        {
          SecurityElement: securityElementNames.Profiles_Module,
          MinimumAccessLevel: 2,
        } as AccessControlEntry,
      ],
    },
  },
  {
    title: 'common.edit',
    path: 'profile/:id/edit',
    component: ProfileEditComponent,
    canActivate: [AuthGuard],
    data: {
      accessControls: [
        {
          SecurityElement: securityElementNames.Profiles_Module,
          MinimumAccessLevel: 2,
        } as AccessControlEntry,
      ],
    },
  },
  {
    title: 'common.profile.relationships',
    path: 'profile/:id/relationships',
    component: ProfileRelationshipsComponent,
    canActivate: [AuthGuard],
  },
  { title: 'common.profile.contacts', path: 'profile/:id/contacts', component: ProfileContactsComponent, canActivate: [AuthGuard] },
  {
    title: 'common.profile.transactions',
    path: 'profile/:id/transactions',
    component: ProfileTransactionsComponent,
    canActivate: [AuthGuard],
  },
  {
    title: 'common.profile.web-content',
    path: 'profile/:id/web-content',
    component: ProfileWebContentComponent,
    canActivate: [AuthGuard],
    data: {
      accessControls: [
        {
          SecurityElement: securityElementNames.Web_Content_Management,
          MinimumAccessLevel: 1,
        } as AccessControlEntry,
      ],
    },
  },
  {
    title: 'profiles.sales-opportunities.header',
    path: 'profiles/salesopportunities',
    component: ProfileSalesOpportunitiesComponent,
    canActivate: [AuthGuard],
    data: {
      features: [FeatureNameEnum.SalesOpportunities],
    },
  },
  {
    title: 'profiles.contact-records.header',
    path: 'profiles/contactrecords',
    component: ProfileContactRecordsComponent,
    canActivate: [AuthGuard],
    data: {
      accessControls: [{ SecurityElement: securityElementNames.Contacts_Module, MinimumAccessLevel: 1 } as AccessControlEntry],
    },
  },
  {
    title: 'profiles.tasks.header',
    path: 'profiles/tasks',
    component: ProfileTasksSearchComponent,
    canActivate: [AuthGuard],
  },
  {
    title: 'committees.search.header',
    path: 'profiles/committees',
    component: CommitteeSearchComponent,
    canActivate: [AuthGuard],
    data: {
      accessControls: [{ SecurityElement: securityElementNames.Committees_Module, MinimumAccessLevel: 1 } as AccessControlEntry],
    },
  },
  {
    title: '',
    path: 'profiles/committee/:id',
    component: CommitteeEditComponent,
    canActivate: [AuthGuard],
    data: {
      accessControls: [{ SecurityElement: securityElementNames.Committees_Module, MinimumAccessLevel: 1 } as AccessControlEntry],
    },
  },
  {
    title: '',
    path: 'profiles/committee/:committeeId/meeting/:meetingId',
    component: CommitteeMeetingEditComponent,
    canActivate: [AuthGuard],
    data: {
      accessControls: [{ SecurityElement: securityElementNames.Committees_Module, MinimumAccessLevel: 1 } as AccessControlEntry],
    },
  },
  {
    title: '',
    path: 'profiles/committee/:committeeId/meeting/new',
    component: CommitteeMeetingEditComponent,
    canActivate: [AuthGuard],
    data: {
      accessControls: [{ SecurityElement: securityElementNames.Committees_Module, MinimumAccessLevel: 1 } as AccessControlEntry],
    },
  },
  { title: 'profiles.search.title', path: 'profiles', component: ProfileFinderComponent },
  { title: 'reports.report-files.manage-report-files', path: 'reports/manage', component: ReportFilesComponent, canActivate: [AuthGuard] },
  {
    title: 'reports.query-tool.title',
    path: 'reports/querytool',
    component: ReportQueryToolComponent,
    canActivate: [AuthGuard],
    data: {
      accessControls: [
        {
          SecurityElement: securityElementNames.Query_Tool,
          MinimumAccessLevel: 1,
        } as AccessControlEntry,
      ],
    },
  },
  {
    title: 'reports.query-tool.title',
    path: 'reports/querytool/:id',
    component: ReportQueryToolComponent,
    canActivate: [AuthGuard],
    data: {
      accessControls: [
        {
          SecurityElement: securityElementNames.Query_Tool,
          MinimumAccessLevel: 1,
        } as AccessControlEntry,
      ],
    },
  },
  {
    title: 'reports.query-tool.title',
    path: 'reports/querytool/:id/:command',
    component: ReportQueryToolComponent,
    canActivate: [AuthGuard],
    data: {
      accessControls: [
        {
          SecurityElement: securityElementNames.Query_Tool,
          MinimumAccessLevel: 1,
        } as AccessControlEntry,
      ],
    },
  },
  {
    title: 'reports.data-dictionary.title',
    path: 'reports/data-dictionary',
    component: DataDictionaryComponent,
    canActivate: [AuthGuard],
  },
  {
    title: 'reports.run-a-report.title',
    path: 'reports/runreport',
    component: ReportsRunAReportComponent,
    canActivate: [AuthGuard],
    data: {
      accessControls: [
        {
          SecurityElement: securityElementNames.Reports_Module,
          MinimumAccessLevel: 1,
        } as AccessControlEntry,
      ],
    },
  },
  {
    title: 'reports.query-tool.title',
    path: 'reports/queries',
    component: ReportsQueryToolSavedQueriesComponent,
    canActivate: [AuthGuard],
    data: {
      accessControls: [
        {
          SecurityElement: securityElementNames.Query_Tool,
          MinimumAccessLevel: 1,
        } as AccessControlEntry,
      ],
    },
  },
  {
    title: 'reports.NAHB-export.title',
    path: 'reports/NAHB-export',
    component: NAHBExportComponent,
    canActivate: [AuthGuard],
  },
  {
    title: 'web-content.manage-web-content.header',
    path: 'web-content',
    component: ManageWebContentComponent,
    canActivate: [AuthGuard],
    data: {
      accessControls: [
        {
          SecurityElement: securityElementNames.Web_Content_Management,
          MinimumAccessLevel: 1,
        } as AccessControlEntry,
      ],
    },
  },
  { title: 'banner-ads.title', path: 'banner-ads', component: BannerAdSearchComponent, canActivate: [AuthGuard] },
  { title: 'coupons.search.coupons', path: 'coupons', component: CouponSearchComponent, canActivate: [AuthGuard] },
  { title: 'public-links.title', path: 'public-links', component: PublicLinksComponent, canActivate: [AuthGuard] },
  // qbo landing
  {
    title: '',
    path: 'qbo-authentication-success',
    canActivate: [AuthGuard],
    component: QboAuthenticationLandingComponent,
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule),
    data: {
      accessControls: [{ SecurityElement: securityElementNames.Admin_Module, MinimumAccessLevel: 1 } as AccessControlEntry],
    },
    canActivate: [AuthGuard],
  },

  {
    path: 'revenue',
    loadChildren: () => import('./revenue/revenue.module').then((m) => m.RevenueModule),
    data: {
      accessControls: [{ SecurityElement: securityElementNames.Revenue_Module, MinimumAccessLevel: 1 } as AccessControlEntry],
    },
    canActivate: [AuthGuard],
  },

  {
    path: 'form-builder',
    loadChildren: () => import('./form-builder/form-builder.module').then((m) => m.FormBuilderModule),
    canActivate: [AuthGuard],
  },
  // only events module right now
  { path: 'profiles', loadChildren: () => import('./profiles/profiles.module').then((m) => m.ProfilesModule) },
  { path: 'ecommerce', loadChildren: () => import('./ecommerce/ecommerce.module').then((m) => m.EcomModule) },
  {
    path: 'events-v4',
    loadChildren: () => import('./events-v4/events-v4.module').then((m) => m.EventsV4Module),
    canActivate: [AuthGuard],
  },
  { path: '**', redirectTo: '/dashboard' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
